import CommonTable from "components/ViewTable/ViewTable";
import { formatIndianAmount } from "helpers/formatIndianAmount";
import React from "react";
import { Badge, Card, Col, Container, Row, Table } from "react-bootstrap";

interface ProductDetailsViewProps {
  data?: any;
}

const ProductDetails: React.FC<ProductDetailsViewProps> = ({ data }) => {

  const productColumns = [
    {
    label: "Sr. No.",
    render: (_row:any, index?: number) => (index ?? 0) + 1,
    align: "center" as const,
  },
    {
      label: "Model",
      render: (row: any) => row?.product?.model?.model_name || row?.model?.model_name || "—",
    },
    {
      label: "Product",
      render: (row: any) =>
        row.product?.product_name || row.product_name || "—",
    },
    {
      label: "Unit",
      render: (row: any) => row.unit?.unit_name || row.unit_name || "—",
    },
    {
      label: "Unit Price",
      render: (row: any) => `₹ ${formatIndianAmount(row.unit_price)}`,
      align: "right" as const,
    },
    {
      label: "Lead Time (Weeks)",
      render: (row: any) => `${row.lead_time || 0} weeks`,
      align: "center" as const,
    },
    {
      label: "Capacity (Per Month)",
      render: (row: any) => row.capacity || 0,
      align: "center" as const,
    },
  ];

  return (

      <Card>
        <Card.Body>
          {/* Products Table */}
          <Row>
            <Col md={12}>
              <h5 className="mb-3">Product Details</h5>
              <CommonTable
                columns={productColumns}
                data={data.products}
                tableClassName="common-table"
                onRowClick={(row) => console.log("Clicked:", row)}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>

  );
};

export default ProductDetails;
